import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import BuyerDashboard from './pages/buyer/Dashboard';
import StoreOwnerDashboard from './pages/store-owner/Dashboard';
import ManufacturerDashboard from './pages/manufacturer/Dashboard';
import AdminDashboard from './pages/admin/Dashboard';
import Stores from './pages/buyer/Stores';
import Products from './pages/buyer/Products';
import Cart from './pages/buyer/Cart';
import StoreProducts from './pages/store-owner/Products';
import StoreOrders from './pages/store-owner/Orders';
import StoreEarnings from './pages/store-owner/Earnings';
import StoreSettings from './pages/store-owner/Settings';
import ManufacturerOrders from './pages/manufacturer/Orders';
import ManufacturerEarnings from './pages/manufacturer/Earnings';
import AdminUsers from './pages/admin/Users';
import AdminStores from './pages/admin/Stores';
import AdminManufacturers from './pages/admin/Manufacturers';
import NotFound from './pages/404';
import ProtectedRoute from './components/ProtectedRoutes';
import StorePage from './pages/store/StorePage';
import CreateProduct from './pages/store-owner/CreateProduct';
import ProductPage from './pages/store/ProductPage';
import StartStore from './pages/store/StartStore';
import ProfilePage from './pages/auth/Profile';
import Checkout from './pages/buyer/Checkout';
import OrdersPage from './pages/buyer/Orders';
import ManufacturerProfile from './pages/manufacturer/Profile';
import ReelPage from './pages/buyer/ReelPage';
import StoreReels from './pages/store-owner/StoreReels';
import FavoritesPage from './pages/buyer/Favourites';

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/store/:slug" element={<StorePage />} />
              <Route path="/store/:slug/products/:productId" element={<ProductPage />} />
              <Route path="/start-store" element={<StartStore />} />
              <Route path="/stores" element={<Stores />} />
              <Route path="/orders" element={<OrdersPage />} />
              <Route path="/favourites" element={<FavoritesPage />} />

              <Route path="/reels" element={<ReelPage />} />
              <Route path="/reels/store/:storeId" element={<ReelPage />} />
              <Route path="/reels/:id" element={<ReelPage />} />
              <Route path="/store-owner/reels" element={<StoreReels />} />
              {/* <Route path="/store/:slug/products" element={<StoreProductsPage />} /> */}
              {/* <Route path="/store/:slug/products/:productId/edit" element={<ProtectedRoute role="store_owner"><EditProduct /></ProtectedRoute>} /> */}
              
              {/* Buyer Routes */}
              <Route path="/dashboard" element={<ProtectedRoute><BuyerDashboard /></ProtectedRoute>} />
              <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
              <Route path="/cart" element={<ProtectedRoute><Cart /></ProtectedRoute>} />
              <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
              <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
              
              {/* Store Owner Routes */}
              <Route path="/store-owner/dashboard" element={<ProtectedRoute role="store_owner"><StoreOwnerDashboard /></ProtectedRoute>} />
              <Route path="/store-owner/products" element={<ProtectedRoute role="store_owner"><StoreProducts /></ProtectedRoute>} />
              <Route path="/store-owner/orders" element={<ProtectedRoute role="store_owner"><StoreOrders /></ProtectedRoute>} />
              <Route path="/store-owner/earnings" element={<ProtectedRoute role="store_owner"><StoreEarnings /></ProtectedRoute>} />
              <Route path="/store-owner/:slug/products/new" element={<ProtectedRoute role="store_owner"><CreateProduct /></ProtectedRoute>} />
              <Route path="/store-owner/settings" element={<ProtectedRoute role="store_owner"><StoreSettings /></ProtectedRoute>} />
              
              {/* Manufacturer Routes */}
              <Route 
                path="/manufacturer/dashboard" 
                element={<ProtectedRoute role="manufacturer"><ManufacturerDashboard /></ProtectedRoute>} 
              />
              <Route 
                path="/manufacturer/profile" 
                element={<ProtectedRoute role="manufacturer"><ManufacturerProfile /></ProtectedRoute>} 
              />
              <Route path="/manufacturer/orders" element={<ProtectedRoute role="manufacturer"><ManufacturerOrders /></ProtectedRoute>} />
              <Route path="/manufacturer/earnings" element={<ProtectedRoute role="manufacturer"><ManufacturerEarnings /></ProtectedRoute>} />
              
              {/* Admin Routes */}
              <Route path="/admin/dashboard" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/users" element={<ProtectedRoute role="admin"><AdminUsers /></ProtectedRoute>} />
              <Route path="/admin/stores" element={<ProtectedRoute role="admin"><AdminStores /></ProtectedRoute>} />
              <Route path="/admin/manufacturers" element={<ProtectedRoute role="admin"><AdminManufacturers /></ProtectedRoute>} />
              
              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;